import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: "/order"
    },
    {
        name: "登录",
        path: '/login',
        component: () => import('../views/Login.vue')
    },
    {
        path: "/", component: () => import("../views/layout.vue"),
        children: [
            {name: "首页", meta: {requireAuth: true}, path: "/home", component: () => import("../views/Home.vue")},
            {name: "订单列表", meta: {requireAuth: true}, path: "/order", component: () => import("../views/order/Index.vue")},

            {name: "公司介绍", meta: {requireAuth: true}, path: "/companyIntro", component: () => import("../views/article/CompanyIntro.vue")},
            {name: "产品介绍", meta: {requireAuth: true}, path: "/productIntro", component: () => import("../views/article/ProductIntro.vue")},
            {name: "使用说明", meta: {requireAuth: true}, path: "/guide", component: () => import("../views/article/Guide.vue")},

            {name: "企业列表", meta: {requireAuth: true}, path: "/enterprise", component: () => import("../views/enterprise/Index.vue")},
            {name: "添加企业", meta: {requireAuth: true}, path: "/enterprise/create", component: () => import("../views/enterprise/Create.vue")},
            {name: "编辑企业", meta: {requireAuth: true}, path: "/enterprise/edit", component: () => import("../views/enterprise/Edit.vue")},

            {name: "设备类型", meta: {requireAuth: true}, path: "/deviceType", component: () => import("../views/deviceType/Index.vue")},
            {name: "添加类型", meta: {requireAuth: true}, path: "/deviceType/create", component: () => import("../views/deviceType/Create.vue")},
            {name: "编辑类型", meta: {requireAuth: true}, path: "/deviceType/edit", component: () => import("../views/deviceType/Edit.vue")},

            {name: "客户设备状态", meta: {requireAuth: true}, path: "/deviceStandard", component: () => import("../views/deviceStandard/Index.vue")},
            {name: "客户设备充值", meta: {requireAuth: true}, path: "/deviceStandard/recharge", component: () => import("../views/deviceStandard/Recharge.vue")},

            {name: "使用信息", meta: {requireAuth: true}, path: "/useinfo", component: () => import("../views/useinfo/Index.vue")},

            {name: "设备列表", meta: {requireAuth: true}, path: "/device", component: () => import("../views/device/Index.vue")},
            {name: "添加设备", meta: {requireAuth: true}, path: "/device/create", component: () => import("../views/device/Create.vue")},
            {name: "编辑设备", meta: {requireAuth: true}, path: "/device/edit", component: () => import("../views/device/Edit.vue")},

            {name: "用户列表", meta: {requireAuth: true}, path: "/user", component: () => import("../views/user/Index.vue")},
            {name: "用户编辑", meta: {requireAuth: true}, path: "/user/edit", component: () => import("../views/user/Edit.vue")},

            {name: "账户列表", meta: {requireAuth: true}, path: "/account", component: () => import("../views/account/Index.vue")},
            {name: "创建账户", meta: {requireAuth: true}, path: "/account/create", component: () => import("../views/account/Create.vue")},
            {name: "编辑账户", meta: {requireAuth: true}, path: "/account/edit", component: () => import("../views/account/Edit.vue")},

            {name: "账户列表", meta: {requireAuth: true}, path: "/epUser", component: () => import("../views/epUser/Index.vue")},
            {name: "创建账户", meta: {requireAuth: true}, path: "/epUser/create", component: () => import("../views/epUser/Create.vue")},
            {name: "编辑账户", meta: {requireAuth: true}, path: "/epUser/edit", component: () => import("../views/epUser/Edit.vue")},

            {name: "报修列表", meta: {requireAuth: true}, path: "/report", component: () => import("../views/report/Index.vue")},

            {name: "banner管理", meta: {requireAuth: true}, path: "/banner", component: () => import("../views/banner/Index.vue")},
            {name: "创建banner", meta: {requireAuth: true}, path: "/banner/create", component: () => import("../views/banner/Create.vue")},
            {name: "编辑banner", meta: {requireAuth: true}, path: "/banner/edit", component: () => import("../views/banner/Edit.vue")},

            {name: "设备参数", meta: {requireAuth: true}, path: "/deviceConfig", component: () => import("../views/settings/DeviceConfig.vue")},
            {name: "设备参数", meta: {requireAuth: true}, path: "/useinfoCycleConfig", component: () => import("../views/settings/UseinfoCycleConfig.vue")},
        ]
    },
    {
        name: "无权限访问", path: '/401', component: () => import('../views/401.vue')
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
